import { supabase } from '../config/supabaseClient';
import { API_BASE_URL } from '../config';

export interface ComplianceStatus {
  domains: Array<{ domain: string; verified: boolean }>;
  dmarc: { configured: boolean; record: string | null };
  bimi: { configured: boolean; svg_url: string | null };
}

export interface ComplianceSettings {
  user_id: string;
  physical_address: string | null;
  preference_center_url: string | null;
  updated_at?: string;
}

const getToken = async () => {
  const sessionResp = await supabase.auth.getSession();
  return (sessionResp as any)?.data?.session?.access_token || '';
};

const withAuth = async (init: RequestInit = {}): Promise<RequestInit> => {
  const token = await getToken();
  return {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...(init.headers || {}),
    },
  };
};

const fetchJSON = async <T>(input: RequestInfo, init?: RequestInit): Promise<T> => {
  const resp = await fetch(input, await withAuth(init));
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `Request failed: ${resp.status}`);
  }
  return resp.json();
};

const complianceService = {
  async getStatus(): Promise<{ success: boolean; status: ComplianceStatus }> {
    const url = `${API_BASE_URL}/api/compliance/status`;
    return fetchJSON(url);
  },

  async getSettings(): Promise<{ success: boolean; settings: ComplianceSettings | null }> {
    const url = `${API_BASE_URL}/api/compliance/settings`;
    return fetchJSON(url);
  },

  async updateSettings(input: Partial<Pick<ComplianceSettings, 'physical_address' | 'preference_center_url'>>): Promise<{ success: boolean; settings: ComplianceSettings }> {
    const url = `${API_BASE_URL}/api/compliance/settings`;
    return fetchJSON(url, { method: 'PUT', body: JSON.stringify(input) });
  },
};

export default complianceService;
